import {t} from 'i18next'

export const getEmailRules = (): any => {
	const requiredText = t<string>('person.email') + t<string>('core.form.required_text')
	const message = t<string>('core.form.email_help')
	return {
		required: requiredText,
		pattern: {value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: message}
	}
}